/* eslint-disable no-undef */

import React from 'react';
import ReactDOM from 'react-dom';
import { CssBaseline } from '@mui/material';
import { StyledEngineProvider } from '@mui/styled-engine';
import 'perfect-scrollbar/css/perfect-scrollbar.css';

import { BrowserRouter } from 'react-router-dom';
import App from './app/App';
// import * as serviceWorker from './serviceWorker';
import { ReactQueryDevtools } from 'react-query/devtools'

import {
    QueryClient,
    QueryClientProvider,
  } from 'react-query'

  // Create a client
const queryClient = new QueryClient({
    defaultOptions:{
        queries:{
            refetchOnWindowFocus:false
        }
    }
});

ReactDOM.render(
    <StyledEngineProvider injectFirst>
         <QueryClientProvider client={queryClient}>
            <BrowserRouter>
                <CssBaseline />
                <App />
            </BrowserRouter>
            <ReactQueryDevtools initialIsOpen={false} />
        </QueryClientProvider>
    </StyledEngineProvider>,
    document.getElementById('root')
);
/* eslint-disable no-undef */
